import { useEffect, useState } from 'react';

/** Значення із затримкою: оновлюється, коли `value` не змінювалося `ms` мілісекунд (пошук осіб без запиту на кожну літеру). */
export function useDebounced<T>(value: T, ms: number): T {
  const [current, setCurrent] = useState(value);
  useEffect(() => {
    const id = setTimeout(() => setCurrent(value), ms);
    return () => clearTimeout(id);
  }, [value, ms]);
  return current;
}
